import { CmsTeaserCard } from '@fcom/core-api';
import { PopoverOptions } from '@fcom/ui-components/index';

export interface BluewingsFiltersItem {
  isActive?: boolean;
  continent?: BluewingsFilterTypeContinent;
  name: string;
  type?: BluewingsFilterType;
  value: string;
}

export interface BluewingsFiltersContinent {
  activeList?: string[];
  count?: number;
  isActive?: boolean;
  name: string;
  value: string;
  type?: BluewingsFilterType;
  countries?: BluewingsFiltersItem[];
}

export enum BluewingsFilterType {
  DESTINATIONS = 'country',
  CONTINENT = 'continent',
  FINNAIR_STORIES = 'finnairStories',
  TRAVEL_EXPERIENCE = 'travelExperience',
  TRAVEL_TIPS = 'travelTips',
  SEASONALITY = 'seasonality',
  WORLD_OF_FINNAIR = 'worldOfFinnair',
}

export enum BluewingsFilterTypeContinent {
  AFRICA = 'africa',
  AMERICAS = 'americas',
  EUROPE = 'europe',
  ASIA_PACIFIC = 'asiaPacific',
  MIDDLE_EAST = 'middleEast',
}

export enum BluewingsContentLocalSettings {
  CONTINENT = 'continent',
  FILTERS = 'filters',
  LIMIT = 'limit',
}

export enum ItemStatus {
  DONE = 'DONE',
  EMPTY = 'EMPTY',
  ERROR = 'ERROR',
  INITIAL = 'INITIAL',
  INITIAL_LOAD = 'INITIAL_LOAD',
  LOADED = 'LOADED',
  LOADING = 'LOADING',
  LOAD_MORE = 'LOAD_MORE',
}

export interface SearchHit {
  articles: CmsTeaserCard[];
  numHits: number;
}

export enum BluewingsQueryParam {
  SUBJECT = 'subject',
  DESTINATIONS = 'dest',
  PAGE = 'pageNum',
}

export const DEFAULT_POPOVER_OPTIONS: PopoverOptions = {
  context: 'bluewings-destinations-filter',
  popoverWidth: 500,
  zIndex: 20,
};

export enum COUNTRY_CODE {
  FI = 'fi',
}

export enum LANG_KEY_VALUE {
  FI = 'fi',
  EN = 'en',
}
